import { useEffect, useState } from "react";
import { URL_API } from "../../utils/helper/helpers";
import axios from "axios";
import { toast } from "react-toastify";
import { Row, Col, Card, CardHeader } from "reactstrap";
import { H4, H6 } from "../../AbstractElements";
import { formatPrice } from "../../utils/helper/helpers";

interface VenteInterface {
    [key: string]: any;
}
interface MvtInterface {
    [key: string]: any;
}
const useVentesListe = (refresh: boolean): VenteInterface[] => {
    const [ventes, setVentes] = useState<VenteInterface[]>([]);
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const fetchVentes = async () => {
            axios.get(`${URL_API}/vente/all`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.data.success) {
                    setVentes(response.data.ventes);
                }

            }).catch(error => {
                if (!error.response.data.success) {
                    toast.info(error.response.data.message);
                }
            })
        };

        fetchVentes();
    }, [refresh]);
    return ventes;
};
export default useVentesListe;

export const useMvtListe = (refresh: boolean): MvtInterface[] => {
    const [mvt, setMvt] = useState<MvtInterface[]>([]);
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const fetchMvt = async () => {
            axios.get(`${URL_API}/mouvement-stock`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.data.success) {
                    setMvt(response.data.mouvements_stock);
                }

            }).catch(error => {
                if (!error.response.data.success) {
                    toast.info(error.response.data.message);
                }
            })
        };

        fetchMvt();
    }, [refresh]);
    return mvt;
};

export const deleteVentes = async ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/vente/delete/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.status == 200) {
            toast.warning("Élément Supprimer avec succès")
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 404 || error.response.status === 500) {
            toast.info(error.response.data.message)
        }
    })

}

export const changeStatus = ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    axios.post(`${URL_API}/vente/changeStatus/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {
        if (response.data.success) {
            toast.success("Status Changé avec success")
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 405) {
            toast.info(error.response.data.message)
        }
    })

}

export const cardVentes = ({ value }: { value: { [key: string]: any } }) => {
    let total_vente = 0;
    let total_montant = 0;

    // Utilisation de `reduce` pour améliorer la lisibilité et l'efficacité
    value.forEach((item: any) => {
        total_vente += 1;
        total_montant += item.vente_total;
    });
    return (
        <Row>
            <Col sm="6">
                <Card className="progress-items pb-0 bg-light-info">
                    <CardHeader className="pb-4 bg-light-info">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">{total_vente.toLocaleString("gn-GN")}</span>
                                </H4>
                                <span></span>
                                <H6 className="f-20 f-w-600 mt-3">
                                    Ventes éffectuées
                                </H6>
                            </div>
                            <div>
                                <i className="icofont icofont-growth f-50"></i>
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>
            <Col md="6">
                <Card className="progress-items pb-0 bg-light-info">
                    <CardHeader className="pb-4 bg-light-info">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">{formatPrice(total_montant)}</span>
                                </H4>
                                <span></span>
                                <H6 className="f-20 f-w-600 mt-3">
                                    Généré
                                </H6>
                            </div>
                            <div>
                                <i className="icofont icofont-money-bag f-50"></i>
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>

        </Row>
    )
};

export const cardMouvement = ({ value }: { value: { [key: string]: any } }) => {
    let total_entree = 0;
    let total_sortie = 0;
    let qte_sortie = 0;
    let qte_entree = 0;

    // Utilisation de `reduce` pour améliorer la lisibilité et l'efficacité
    value.forEach((item: any) => {
        if (item.type_mouvement == 'sortie') {
            qte_sortie += item.quantite
            total_sortie += item.prix_unitaire * item.quantite;
        }
        if (item.type_mouvement == 'entree') {
            total_entree += item.prix_unitaire * item.quantite;
            qte_entree += item.quantite
        }
    });
    return (
        <Row>
            <Col sm="6">
                <Card className="progress-items pb-0 bg-light-success">
                    <CardHeader className="pb-4 bg-light-success">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">{qte_entree.toLocaleString("gn-GN")} tonnes</span>
                                </H4>
                                <span>{formatPrice(total_entree)}</span>
                                <H6 className="f-20 f-w-600 mt-3">
                                    Entrée
                                </H6>
                            </div>
                            <div>
                                <i className="icofont icofont-money-bag f-50"></i>
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>
            <Col md="6">
                <Card className="progress-items pb-0 bg-light-danger">
                    <CardHeader className="pb-4 bg-light-danger">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">
                                        {qte_sortie.toLocaleString("gn-GN")} tonnes
                                    </span>
                                </H4>
                                <span>{formatPrice(total_sortie)}</span>
                                <H6 className="f-20 f-w-600 mt-3">
                                    Sortie
                                </H6>
                            </div>
                            <div>
                                <i className="icofont icofont-money-bag f-50"></i>
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>

        </Row>
    )
};